export default "__VITE_ASSET__BXEmqSMn__"